'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellersIfNeeded = exports.fetchAllSellersIfNeeded = exports.shouldFetchSeller = exports.getSeller = exports.shouldFetchSellers = exports.getMatchingSellersFunction = exports.getAllSellersForDirectoryPage = exports.areAllSellersLoading = exports.LOAD_SELLERS_SUCCESS = exports.LOAD_SELLERS_REQUEST = exports.LOAD_SELLERS_FAIL = exports.LOAD_ALL_SELLERS_SUCCESS = exports.LOAD_ALL_SELLERS_REQUEST = exports.LOAD_ALL_SELLERS_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _fetchBatch = require('./fetchBatch');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('./user');

var _config = require('./config');

var _groupBy = require('lodash/groupBy');

var _groupBy2 = _interopRequireDefault(_groupBy);

var _catalogAd = require('./catalogAd');

var _catalog = require('./catalog');

var _home = require('./home');

var _item = require('./item');

var _upcomingCatalogs = require('./upcomingCatalogs');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

var _sellerCatalogCounts = require('./sellerCatalogCounts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ALL_SELLERS_FAIL = exports.LOAD_ALL_SELLERS_FAIL = 'la/domain/allSellers/LOAD_FAIL';
var LOAD_ALL_SELLERS_REQUEST = exports.LOAD_ALL_SELLERS_REQUEST = 'la/domain/allSellers/LOAD_REQUEST';
var LOAD_ALL_SELLERS_SUCCESS = exports.LOAD_ALL_SELLERS_SUCCESS = 'la/domain/allSellers/LOAD_SUCCESS';

var LOAD_SELLERS_FAIL = exports.LOAD_SELLERS_FAIL = 'la/domain/sellers/LOAD_FAIL';
var LOAD_SELLERS_REQUEST = exports.LOAD_SELLERS_REQUEST = 'la/domain/sellers/LOAD_REQUEST';
var LOAD_SELLERS_SUCCESS = exports.LOAD_SELLERS_SUCCESS = 'la/domain/sellers/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var FETCH_SET_SIZE = 120;

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loadedSellers: false,
    loading: [],
    loadingSellers: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loadedSellers = void 0;
    var loading = void 0;
    var loadingSellers = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ALL_SELLERS_FAIL:
            return (0, _extends3.default)({}, state, {
                loadingSellers: false
            });
        case LOAD_ALL_SELLERS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loadingSellers: true
            });
        case LOAD_SELLERS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.sellerIds)
            });
        case LOAD_SELLERS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ALL_SELLERS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.sellerId] = (0, _extends3.default)({}, item);
                loaded[item.sellerId] = time;
                loading = (0, _difference2.default)(loading, [item.sellerId]);
            });
            loadingSellers = false;
            loadedSellers = true;
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loadedSellers: loadedSellers,
                loading: loading,
                loadingSellers: loadingSellers
            });
        case _catalogAd.LOAD_CATALOG_AD_SUCCESS:
        case _catalog.LOAD_CATALOGS_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case LOAD_SELLERS_SUCCESS:
        case _upcomingCatalogs.LOAD_UPCOMING_CATALOGS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.sellers) {
                action.payload.sellers.forEach(function (item) {
                    existing[item.sellerId] = (0, _extends3.default)({}, item);
                    loaded[item.sellerId] = time;
                    loading = (0, _difference2.default)(loading, [item.sellerId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var sellerSelector = function sellerSelector(state) {
    return state.domain.seller;
};
var idSelector = function idSelector(state, id) {
    return id;
};

// get the "byId" part of the state
var byIdSelector = (0, _reselect.createSelector)(sellerSelector, function (sellers) {
    return sellers.byId;
});

var areAllSellersLoaded = function areAllSellersLoaded(state) {
    return state.domain.seller.loadedSellers || false;
};

var areAllSellersLoading = exports.areAllSellersLoading = function areAllSellersLoading(state) {
    return state.domain.seller.loadingSellers || false;
};

var getAllSellers = (0, _reselect.createSelector)(byIdSelector, function (byId) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    });
});

// This is pretty gross.  Hopefully we can just get the correct form of data
var generateStateLists = function generateStateLists() {
    var sellers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var europeSellers = sellers.europe || [];
    var usSellers = sellers.us || [];
    var worldSellers = sellers.world || [];

    var europeSellerByState = (0, _groupBy2.default)(europeSellers.sort(function (a, b) {
        if (a.country.toLowerCase() > b.country.toLowerCase()) {
            return 1;
        }
        return -1;
    }), function (seller) {
        return seller.countryCode;
    });
    var usSellersByState = (0, _groupBy2.default)(usSellers.sort(function (a, b) {
        if (a.stateName.toLowerCase() > b.stateName.toLowerCase()) {
            return 1;
        }
        return -1;
    }), function (seller) {
        return seller.stateCode;
    });
    var worldSellersByState = (0, _groupBy2.default)(worldSellers.sort(function (a, b) {
        if (a.country.toLowerCase() > b.country.toLowerCase()) {
            return 1;
        }
        return -1;
    }), function (seller) {
        return seller.countryCode;
    });

    var europe = [];
    (0, _keys2.default)(europeSellerByState).forEach(function (key) {
        if (!europeSellerByState[key][0].country) {
            return;
        }
        var country = {
            name: europeSellerByState[key][0].country,
            sellers: europeSellerByState[key].map(function (seller) {
                return { name: seller.name, sellerId: seller.sellerId };
            }).sort(function (a, b) {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return -1;
            })
        };
        europe.push(country);
    });

    var us = [];
    (0, _keys2.default)(usSellersByState).forEach(function (key) {
        if (!usSellersByState[key][0].stateName) {
            return;
        }
        var state = {
            name: usSellersByState[key][0].stateName,
            sellers: usSellersByState[key].map(function (seller) {
                return { name: seller.name, sellerId: seller.sellerId };
            }).sort(function (a, b) {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return -1;
            })
        };
        us.push(state);
    });

    var world = [];
    (0, _keys2.default)(worldSellersByState).forEach(function (key) {
        if (!worldSellersByState[key][0].country) {
            return;
        }
        var country = {
            name: worldSellersByState[key][0].country,
            sellers: worldSellersByState[key].map(function (seller) {
                return { name: seller.name, sellerId: seller.sellerId };
            }).sort(function (a, b) {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return -1;
            })
        };
        world.push(country);
    });

    return {
        europe: europe,
        us: us,
        world: world
    };
};

var getFilteredAllSellers = (0, _reselect.createSelector)(getAllSellers, function (allSellers) {
    return allSellers.filter(function (x) {
        // Premiere Props has 3 seller ids now, filter out the first two from the directory page
        return x.sellerId !== 675 && x.sellerId !== 759;
    });
});

var getAllSellersForDirectoryPage = exports.getAllSellersForDirectoryPage = (0, _reselect.createSelector)(getFilteredAllSellers, function (allSellers) {
    var sellers = (0, _groupBy2.default)(allSellers, function (seller) {
        return seller.regionCode;
    });
    return generateStateLists(sellers);
});

var getMatchingSellersFunction = exports.getMatchingSellersFunction = function getMatchingSellersFunction(state) {
    return function (query) {
        var sellers = getFilteredAllSellers(state);
        return sellers.filter(function (seller) {
            var searchTokens = query.toLowerCase().split(/\s/);
            var matchingTokens = searchTokens.filter(function (token) {
                var _seller$name = seller.name,
                    name = _seller$name === undefined ? '' : _seller$name;

                return ('' + name).toLowerCase().indexOf(token) !== -1;
            });
            var doesMatch = matchingTokens.length === searchTokens.length;
            return doesMatch;
        });
    };
};

var shouldFetchSellers = exports.shouldFetchSellers = function shouldFetchSellers(state) {
    return !areAllSellersLoaded(state) && !areAllSellersLoading(state);
};

var getLoadTimeForSeller = function getLoadTimeForSeller(state, sellerId) {
    return state.domain.seller.loaded[sellerId] || 0;
};

var isSellerLoading = function isSellerLoading(state, sellerId) {
    return state.domain.seller.loading.indexOf(sellerId) !== -1;
};

var getSeller = exports.getSeller = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var shouldFetchSeller = exports.shouldFetchSeller = function shouldFetchSeller(state, sellerId) {
    if (!sellerId) return false;
    var item = getSeller(state, sellerId);
    if (item) {
        var loaded = getLoadTimeForSeller(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerLoading(state, sellerId);
    return !loading;
};

var whichSellersNeeded = function whichSellersNeeded(state, sellerIds) {
    return sellerIds.filter(function (sellerId) {
        return shouldFetchSeller(state, sellerId);
    });
};

/* ACTION CREATORS */
// all sellers
var loadAllSellersFail = function loadAllSellersFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_ALL_SELLERS_FAIL
    };
};

var loadAllSellersRequest = function loadAllSellersRequest() {
    return {
        type: LOAD_ALL_SELLERS_REQUEST
    };
};

var loadAllSellersSuccess = function loadAllSellersSuccess(results) {
    return {
        meta: { actionTime: Date.now() },
        payload: results,
        type: LOAD_ALL_SELLERS_SUCCESS
    };
};

var loadAllSellers = function loadAllSellers() {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadAllSellersRequest());
        return _api.Seller.fetchSellers({ deployment: deployment }).then(function (response) {
            dispatch(loadAllSellersSuccess(response.data));
        }).catch(function (error) {
            dispatch(loadAllSellersFail(error));
        });
    };
};

var fetchAllSellersIfNeeded = exports.fetchAllSellersIfNeeded = function fetchAllSellersIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchSellers(getState())) {
            return dispatch(loadAllSellers());
        }
        return _promise2.default.resolve();
    };
};

// seller
var loadSellers = function loadSellers(sellerIds, loadingId, isFinalFetch) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerIds,
                                type: LOAD_SELLERS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Seller.fetchSellersByIds({ authToken: authToken, deployment: deployment, sellerIds: sellerIds });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerIds: sellerIds },
                                payload: response.data,
                                type: LOAD_SELLERS_SUCCESS
                            });
                            if (isFinalFetch) {
                                dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
                            }
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerIds: sellerIds },
                                payload: _context.t0,
                                type: LOAD_SELLERS_FAIL
                            });
                            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x4, _x5) {
            return _ref.apply(this, arguments);
        };
    }();
};

var loadSellersInSets = function loadSellersInSets(ids, setSize, loadingId) {
    return function (dispatch) {
        if (ids.length > setSize) {
            return dispatch(loadSellers(ids.slice(0, setSize), loadingId, false)).then(function () {
                dispatch(loadSellersInSets(ids.slice(setSize), setSize, loadingId));
            });
        }
        return dispatch(loadSellers(ids, loadingId, true));
    };
};

var fetchSellersIfNeeded = exports.fetchSellersIfNeeded = function fetchSellersIfNeeded(sellerIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';

    return function (dispatch, getState) {
        var neededSellers = whichSellersNeeded(getState(), sellerIds);
        var neededCatalogCounts = (0, _sellerCatalogCounts.whichSellerCatalogCountsNeeded)(getState(), sellerIds);
        var needed = (0, _union2.default)(neededSellers, neededCatalogCounts);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadSellersInSets(needed, FETCH_SET_SIZE, loadingId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/seller.js
// module id = 4q18
// module chunks = 60